import React from "react";

const EmptyComponent: React.FC<any> = () => {
    return(
        <>
        </>
    )
}

export { EmptyComponent };